import React from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../enums/queryKeys'
import { fetchSubscriptionInvoices } from '../../query-api/subscription-invoices-query'
import { SubscriptionInvoicesList } from '../SubscriptionInvoicesList'

export const SubscriptionInvoices = () => {
  const { organization } = useUserOrganization()
  const { data: invoicesData, isLoading: isLoadingInvoices } = useQuery(
    [QueryKeys.SubscriptionInvoices, organization?.id],
    () => fetchSubscriptionInvoices(organization?.id as string),
    {
      enabled: !!organization?.id,
    },
  )

  return <SubscriptionInvoicesList invoices={invoicesData} isLoading={isLoadingInvoices} />
}
